<template>
  <div class="app-main-inner app-main-page" style="height:auto">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Partners.batchChangeSalesperson')"
      width="950px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row">
        <div class="filters" style="display: inline;width: 520px;">
          <el-form :inline="true" label-width="70px" label-position="left">
            <!--用户名称-->
            <el-form-item :label="$t('Partners.userName')">
              <cargo-advance-select
                no="companyUser"
                :select-type="selectTypeNames.basic_data_User"
                filterable
                :callback-params="{key:'companyUser'}"
                callback-method-type="value"
                :default-value="filter.companyUser"
                :fields="['chineseName']"
                options-width="230px"
                @parentCallBack="selectCargoItem"
              />
            </el-form-item>
            <!--合作伙伴-->
            <el-form-item :label="$t('baseInfo.partner.companyName')">
              <el-input v-model="filter.companyName" no="companyName" />
            </el-form-item>
          </el-form>
        </div>
        <div class="triggers">
          <el-button no="toQuery" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
          <el-button no="showEditDialog" type="primary" @click="showEditDialog">{{ $t('Partners.batchModifySalesperson') }}</el-button>
          <el-button no="exportExcel" type="primary" @click="exportExcel">{{ $t('Partners.exportModificationResults') }}</el-button>
        </div>
      </div>
      <div class="app-main-inner-row row-grid" style="min-height:350px;">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="app-main-inner-row row-pagination" style="padding-right:0px;">
        <cargo-pagination
          v-show="total>0"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </el-dialog>
    <!-- 编辑弹窗 -->
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('Partners.modifySalesperson')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row">
        <el-form label-width="70px" label-position="left">
          <el-form-item :label="$t('Partners.userName')">
            <cargo-advance-select
              no="companyUser1"
              :select-type="selectTypeNames.basic_data_User"
              :method-params="{active:true}"
              filterable
              :callback-params="{key:'sales'}"
              callback-method-type="value"
              :default-value="editDialog.companyUser"
              :fields="['chineseName']"
              options-width="230px"
              @parentCallBack="changeDialogCompanyUser"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as CargoOfRoleTypeUtil from '@/class/cargo/model/utils/CargoOfRoleTypeUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { getCompanyList, updateSales } from '@/api/company'
import { deepClone } from '@/utils'
import { getAllUsersByOffice } from '@/api/user'

export default {
  name: 'EditPartnerSale',
  components: { cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      innerVisible: false,
      lobs: [],
      roleTypes: [],
      selectTypeNames: TYPE_NAMES,
      filter: {
        isEditSale: true, // 标记是修改销售人员
        companyUser: null,
        companyName: '',
        currentBranchId: '',
        branchIds: [],
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Partners.partnerAbbreviation'),
          field: 'shortName'
        },
        {
          headerName: this.$t('Partners.chineseNameOfPartner'),
          field: 'chineseName'
        },
        {
          headerName: this.$t('SeaExport.ChargeBranchId'),
          field: 'branchId',
          cellRenderer: params => {
            if (params.value === 1) {
              return 'HQ'
            }
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
            return value || params.value
          }
        },
        {
          headerName: this.$t('Partners.salesman'),
          field: 'sales',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('Partners.isItSuccessful'),
          field: 'isSucceed',
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        }
      ],
      rowData: [],
      gridApi: null,
      editDialog: {
        visible: false,
        title: '',
        companyUser: '',
        form: {
          uuidList: [],
          title: '',
          taxAccount: '',
          address: '',
          telephone: '',
          tenantId: ''
        }
      }
    }
  },
  computed: {
    isZh() {
      return this.$i18n.locale === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.filter = this.filterInit()
        this.rowData = []
      }
    }
  },
  async created() {
    this.lobs = SystemConstants.LOBS
    this.roleTypes = await CargoOfRoleTypeUtil.getRoleTypes()
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.onGridDateRendered()
    },
    async toQuery() {
      if (!this.filter.companyUser) {
        this.$message.warning(this.$t('Partners.enterUserInformation'))
        return
      }
      const currentOffice = this.$store.getters.currentOffice
      this.filter.currentBranchId = currentOffice.officeId
      if (currentOffice.code !== 'HQ') {
        this.filter.branchIds = [currentOffice.officeId, 1]
      }
      this.filter.roleType = CargoOfRoleType.SALES_TYPE.code
      this.filter.companyType = 'CUSTOMER'
      getCompanyList(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.onGridDateRendered()
      })
    },
    onGridDateRendered() {
      const columnApi = this.gridApi.columnController.columnApi
      const columnIds = []
      this.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    },
    selectCargoItem(item) {
      this.filter[item.key] = item.value
    },
    showEditDialog() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.editDialog.form = {
        uuidList: [],
        title: '',
        taxAccount: '',
        address: '',
        telephone: '',
        tenantId: rows[0].tenantId
      }
      for (const item of rows) {
        this.editDialog.form.uuidList.push(item.uuid)
      }
      this.editDialog.companyUser = ''
      this.editDialog.visible = true
    },
    save() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows) {
        this.$message.info(this.$t('Partners.selectAUserToModify'))
        return
      }
      const obj = {}
      obj.userId = this.editDialog.companyUser
      obj.uuids = rows.map(row => row.uuid)
      obj.branchId = this.$store.getters.currentOfficeId
      updateSales(obj).then(res => {
        // 局部数据更新
        for (const row of this.rowData) {
          if (obj.uuids.includes(row.uuid)) {
            row.sales = obj.userId
            row.isSucceed = this.$t('Message.Yes')
          }
        }
        this.gridApi.refreshCells({ force: true })
        this.$emit('callback', obj.uuids)
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      })
    },
    exportExcel() {
      let rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Partners.selectRecordToExport'))
        return
      }
      rows = deepClone(rows)
      const fileName = this.$t('Partners.batchChangeSales') + new Date().getTime().toString() + '.xls'
      const tHeader = []
      const filterVal = []
      // 对行中每列的值做处理
      for (const item of rows) {
        if (!item) continue
        for (const colDef of this.columnDefs) {
          const dataField = colDef.field
          if (!colDef.headerName || !dataField) continue
          if (!tHeader.includes(colDef.headerName) && !filterVal.includes(dataField)) {
            tHeader.push(colDef.headerName)
            filterVal.push(dataField)
          }
          let data = item.hasOwnProperty(dataField) ? item[dataField] : ''
          // 进行labelFunction 处理
          if (colDef.cellRenderer && typeof colDef.cellRenderer !== 'string') {
            const params = { data: item, value: item[dataField] }
            params.colDef = { field: colDef.field }
            data = colDef.cellRenderer(params)
          }
          if (data && typeof data === 'string') {
            data = StrUtils.replaceSpecialCharacter(data)
          }
          item[dataField] = data
        }
      }
      import('@/vendor/Export2Excel').then(excel => {
        const data = this.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: fileName
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    changeDialogCompanyUser(item) {
      this.editDialog.companyUser = item.value
    },
    filterInit() {
      return {
        isEditSale: true, // 标记是修改销售人员
        companyUser: null,
        companyName: '',
        currentBranchId: '',
        branchIds: [],
        pageNum: 1,
        pageSize: 50
      }
    }
  }
}
</script>

<style>
</style>
